// Packages
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import DOMPurify from "dompurify";
import { faCircleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function DateField(props) {
  const {
    label,
    required,
    id,
    position,
    value,
    options,
    custom_field_id,
    errors,
    setCustomField,
    custom,
    is_date_restricted,
  } = props;
  const elementId = `custom_field_${props.area}_${custom_field_id}`;
  const { t } = useTranslation();
  const doingRequest = useSelector((state) => state.ui.doingRequest);
  const store_timezone = useSelector(
    (state) => state.checkoutStore.information.store_timezone
  );
  const { colors } = useSelector((state) => state.checkoutStore);

  return (
    <div className={`col-12 mb-3 form-group`}>
      <div
        className={`input-placeholder floating-label-wrap ${
          errors[elementId] ? "error-div-highlight" : ""
        }`}
      >
        <label htmlFor={elementId} className="label-checkout">
          <span
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(label, {
                ADD_ATTR: ["target"],
              }).replace(/<\/?p>/g, ""),
            }}
          />
          {required ? " *" : ""}
        </label>
        <input
          type="date"
          className="floating-label-field floating-label-field--s1 date-picker"
          disabled={doingRequest}
          id={elementId}
          placeholder={label}
          onChange={(e) =>
            setCustomField(
              elementId,
              custom_field_id,
              e.target.value,
              props.area
            )
          }
          value={(value != null && value) || ""}
          min={
            is_date_restricted
              ? new Date().toLocaleDateString("en-CA", {
                  timeZone: store_timezone,
                })
              : undefined
          } // Set min attribute to today's date
        />
      </div>
      <div
        className={`field-error ${errors[elementId] ? "" : "hidden-error"}`}
        style={{
          display: errors[elementId] ? "flex" : "",
          alignItems: "center",
        }}
      >
        <FontAwesomeIcon
          icon={faCircleExclamation}
          style={{ paddingRight: "2px" }}
          size="sm"
          fixedWidth
        />
        {errors[elementId] && t(errors[elementId])}
      </div>
    </div>
  );
}

export default DateField;
